import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { importOnIdle, installChunkErrorRecovery, installHydrationDiagnostics, assertRuntimeState } from "@/lib/runtime";
import { initializeTheme } from "@/lib/theme";
import { ensureLanguageSynchronization, initializeLanguage } from "@/lib/routes";

initializeTheme();
initializeLanguage(window.location.pathname);
installChunkErrorRecovery();
installHydrationDiagnostics();
assertRuntimeState([
  () => ensureLanguageSynchronization(window.location.pathname),
]);

createRoot(document.getElementById("root")!).render(<App />);

importOnIdle(() => import("@/components/home/CategoriesSection"));
importOnIdle(() => import("@/components/home/SpotlightGallery"));
importOnIdle(() => import("@/components/home/ManufacturerConstellation"));
importOnIdle(() => import("@/components/home/SceneTransition"));
// Side-effect import: install global SFX delegation + auto-unlock listeners
// so site-wide cinematic sound is live from the very first interaction.
importOnIdle(() => import("@/lib/audioBus"));
